import { QueryClient } from "@tanstack/react-query"

/**
 * Shared QueryClient instance so route loaders can prefetch data into the same
 * cache that components use (e.g. for intent preload).
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
})
